import sahappConfig from '../../../../FAKE/sahappConfig-search.json';

const MIN_STAY_INCLUSIVE_DAY = 1;
const MIN_STAY_DAYS = 30 - MIN_STAY_INCLUSIVE_DAY;
const DEFAULT_LOCALE = 'en';

const COLORS = {
  green: '#32B496',
  blue: '#42ade3'
};

const GlobalSettings = function GlobalSettings(settings) {
  this.settings = settings || {};
};

GlobalSettings.prototype.getDatePickerFormat = function getDatePickerFormat() {
  return this.settings.dateFormat || 'YYYY-MM-DD';
};

/**
 * Used in landing page and mapsearch.
 *
 * @returns {number} minimum stay
 */
GlobalSettings.prototype.getMoveDatesInterval = function getSettingsFn() {
  return this.settings.moveDatesIntervalInDays || 180;
};

GlobalSettings.prototype.getMinStay = function getSettingsFn() {
  return MIN_STAY_DAYS;
};

GlobalSettings.prototype.getOriginUrl = function getOriginUrl() {
  return this.settings.originUrl;
};

GlobalSettings.prototype.getShowTranslatedContent = function getShowTranslatedContent() {
  return this.settings.showTranslatedContent;
};

GlobalSettings.prototype.getGoogleMapsKey = function getGoogleMapsKey() {
  return this.settings.googleMapsKey || '';
};

GlobalSettings.prototype.getColor = function getColor(colorStr) {
  return COLORS[colorStr];
};

GlobalSettings.prototype.getDefaultLocale = function getDefaultLocale() {
  return DEFAULT_LOCALE;
};

GlobalSettings.prototype.getCurrentYear = function getCurrentYearFn() {
  return this.settings.currentYear || 2016;
};

GlobalSettings.prototype.getRequest = function getRequestFn() {
  return this.settings.request || {};
};

GlobalSettings.prototype.getStaticPagesUrls = function getStaticPagesUrlsFn() {
  return this.settings.multilanguageStaticPages || {};
};

// export default new GlobalSettings(window.sahappConfig);
export default new GlobalSettings(sahappConfig);
